<script setup lang="ts">
import LabelBase from '@/components/label/LabelBase.vue'
import type { ColorKey } from '@/types/tailwind'

defineProps<{
  title?: string
  color?: ColorKey
}>()
</script>

<template>
  <div>
    <label-base v-if="title" size="sm" color="stone" class="block font-sans capitalize">{{
      title
    }}</label-base>
    <label-base class="block" :color="color"><slot></slot></label-base>
  </div>
</template>

<style scoped></style>
